import qs from "qs";

export const parseParams = (search, options = {}) =>
  qs.parse(search, { ignoreQueryPrefix: true, ...options });
